import React from "react";

import {
	Segment,
	Container,
	Header,
	Icon,
	Button,
	Image,
	Form,
} from "semantic-ui-react";

class Uploader extends React.Component {
	state = {
		photo: null,
	};

	onFile = (eve) => {
		console.log("Got Image");
		const photo = eve.target.files[0];
		if (photo) {
			this.props.onPhoto(photo);
		}
		// this.props.onPhoto(this.getImage(eve.target.files[0]));
	};

	getImage = (photo) => {
		return URL.createObjectURL(photo);
	};

	render() {
		return (
			<Segment placeholder>
				<Header icon>
					<Icon name="image" style={{ marginBottom: "-20px" }} />
					Choose Image to Get Started
				</Header>

				<Button
					icon
					primary
					labelPosition="left"
					onClick={(eve) => {
						eve.preventDefault();
						document.getElementById("photo-in-zzz").click();
					}}
				>
					Upload Image
					<Icon name="upload" />
				</Button>
				<input
					type="file"
					name="photo"
					onChange={this.onFile}
					id="photo-in-zzz"
					hidden
				/>
			</Segment>
		);
	}
}

export default Uploader;
